import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAccountSocialMediaSignatureTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({
			templateId,
			impersonationContext,
		}: {
			templateId: string | null;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAccount>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'account/preferences/socialMediaSignatureTemplate',
					impersonationContext,
				}),
				'PUT',
				{ templateId }
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['template'] });
			onSuccess?.();
		},
		onError,
	});
}
